// extracted by mini-css-extract-plugin
export default {"container":"hotel_container__leTBP","leftArrowButton":"hotel_leftArrowButton__sHcZe","rightArrowButton":"hotel_rightArrowButton__cP0q-","editIcon":"hotel_editIcon__JOKcx"};